import { dispatch, getState, subscribe } from '../state/store';
import { startClock } from './Clock';
import { openApp } from './WindowManager';
import { APPS } from './apps/registry';

export function initTaskbar(root: HTMLElement): void {
  const bar = document.createElement('div');
  bar.id = 'taskbar';

  const start = document.createElement('button');
  start.type = 'button';
  start.className = 'start-btn';
  start.textContent = 'Start';

  const tasks = document.createElement('div');
  tasks.className = 'task-buttons';

  const tray = document.createElement('div');
  tray.className = 'tray';
  const speaker = document.createElement('button');
  speaker.type = 'button';
  speaker.className = 'tray-speaker';
  speaker.setAttribute('aria-label', 'Mute');
  const clock = document.createElement('span');
  tray.append(speaker, clock);

  bar.append(start, tasks, tray);
  root.append(bar);

  const menu = document.createElement('div');
  menu.className = 'start-menu';
  menu.hidden = true;
  const stripe = document.createElement('div');
  stripe.className = 'start-stripe';
  stripe.textContent = 'Ben95';
  const items = document.createElement('div');
  items.className = 'start-items';

  const item = (label: string, fn: () => void, disabled = false) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.textContent = label;
    if (disabled) {
      b.setAttribute('aria-disabled', 'true');
      b.disabled = true;
    }
    b.addEventListener('click', () => {
      if (disabled) return;
      dispatch({ type: 'TOGGLE_START', open: false });
      fn();
    });
    return b;
  };

  items.append(
    item('About', () => openApp('about')),
    item('Projects', () => openApp('projects')),
    item('Games', () => openApp('games')),
    item('Music', () => openApp('music')),
    item('Videos', () => openApp('videos')),
    item('Notepad', () => openApp('notepad')),
    item('My Computer', () => openApp('browser', { pageId: 'ben' })),
    item("Wrack 'n Crack", () => openApp('wrack')),
    item('Settings', () => openApp('control')),
    item('Help', () => openApp('about')),
  );
  const sep = document.createElement('div');
  sep.className = 'start-sep';
  items.append(sep);
  items.append(item('Shut Down...', () => showShutdown()));
  menu.append(stripe, items);
  root.append(menu);

  start.addEventListener('click', (e) => {
    e.stopPropagation();
    dispatch({ type: 'TOGGLE_START' });
  });
  speaker.addEventListener('click', () => dispatch({ type: 'SET_MUTE', mute: !getState().mute }));

  startClock((t) => {
    clock.textContent = t;
  });

  const paint = () => {
    const s = getState();
    start.classList.toggle('is-open', s.startOpen);
    menu.hidden = !s.startOpen;
    speaker.textContent = s.mute ? '×♪' : '♪';
    tasks.replaceChildren();
    for (const w of s.windows) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'task-btn';
      b.classList.toggle('is-active', s.focusedId === w.id && w.state !== 'minimized');
      b.textContent = APPS[w.appId]?.title ?? w.title;
      b.addEventListener('click', () => {
        if (w.state === 'minimized') dispatch({ type: 'RESTORE', id: w.id });
        dispatch({ type: 'FOCUS_WINDOW', id: w.id });
      });
      tasks.append(b);
    }
  };

  subscribe(paint);
  paint();
}

function showShutdown(): void {
  let screen = document.getElementById('shutdown-screen');
  if (!screen) {
    screen = document.createElement('div');
    screen.id = 'shutdown-screen';
    const msg = document.createElement('p');
    msg.textContent = "It's now safe to turn off your computer.";
    const restart = document.createElement('button');
    restart.type = 'button';
    restart.className = 'w95-push';
    restart.textContent = 'Restart Ben95';
    restart.addEventListener('click', () => {
      screen?.classList.add('is-hidden');
    });
    screen.append(msg, restart);
    document.getElementById('app')?.append(screen);
  }
  screen.classList.remove('is-hidden');
}
